import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { apiFavoriteSave } from '@/request/api';

export default ({ getFavoriteList }) => {

    const creating = ref(false);// 是否在新建收藏夹
    const favoriteName = ref('');
    const loading = ref(false);

    // 关闭新建收藏夹
    function closeCreate() {
        creating.value = false;
        favoriteName.value = '';
        loading.value = false;
    }

    // 新建
    async function createCollection() {
        if (loading.value) return;
        if (!favoriteName.value) {
            ElMessage.error('请输入收藏夹名称');
            return;
        }
        loading.value = true;
        try {
            const { code } = await apiFavoriteSave({ favoriteName: favoriteName.value });
            if (code !== '0') return;
            getFavoriteList();
            closeCreate();
        } finally {
            loading.value = false;
        }
    }

    return { creating, closeCreate, favoriteName, createCollection, loading }
}